// Copyright (c) 2022 by Move Closer

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 *
 * Note! Ordering is very important within this map.
 */
export const tabs: Record<string, string> = {
  heroSection: 'description',
  boxSection: 'productFeatures',
  columnSection: 'elements',
  stepSection: 'methodOfUse',
  inci: 'inci'
}
